import {
  companyFormSchema,
  companyInitForm,
} from '../../features/company/components/companyForm/formDatas';
import {
  userFormSchema,
  userInitForm,
} from '../../features/users/components/userForm/formDatas';

export const detailsInitialValues = ({
  user,
  company,
}: {
  user: IUser | null;
  company: ICompany | null;
}) => {
  const initUser = userInitForm(user);
  const initCompany = companyInitForm(company);

  return {
    ...initUser,
    ...initCompany,
  };
};

export const detailsSchema = userFormSchema.concat(companyFormSchema);
